import classNames from "classnames";
import dayjs from "dayjs";
import "flatpickr/dist/themes/light.css";
import PropTypes from "prop-types";
import React, { useState } from "react";
import Flatpickr from "react-flatpickr";
import Select from "react-select";
import * as _ from "lodash";
import { Col, FormFeedback, Input, InputGroup, Label } from "reactstrap";
import NibbleInputImage from "./NibbleInputImage";
import { format } from "prettier";

export const Spanish = {
  weekdays: {
    shorthand: ["Dom", "Lun", "Mar", "Mié", "Jue", "Vie", "Sáb"],
    longhand: [
      "Domingo",
      "Lunes",
      "Martes",
      "Miércoles",
      "Jueves",
      "Viernes",
      "Sábado",
    ],
  },
  months: {
    shorthand: [
      "Ene",
      "Feb",
      "Mar",
      "Abr",
      "May",
      "Jun",
      "Jul",
      "Ago",
      "Sep",
      "Oct",
      "Nov",
      "Dic",
    ],
    longhand: [
      "Enero",
      "Febrero",
      "Marzo",
      "Abril",
      "Mayo",
      "Junio",
      "Julio",
      "Agosto",
      "Septiembre",
      "Octubre",
      "Noviembre",
      "Diciembre",
    ],
  },
  ordinal: function () {
    return "º";
  },
  firstDayOfWeek: 1,
  rangeSeparator: " a ",
  time_24hr: true,
};

const NibbleBaseInput = ({
  md = 6,
  label = "label",
  fieldName = "field_name",
  validation,
  fieldType = "text",
  placeHolder = "",
  selectItems = [],
  selectIsClearable = true,
  selectClearableValue = null,
  selectOptionValue = (option) => option.id,
  selectOptionLabel = (option) => `${option.name}`,
  selectIsSearchable = true,
  selectStringify = null,
  postFileFunction = () => { },
  itemFile = null,
  maxLength = null,
  readOnly = false,
  disabled = false,
  format = null,
  accept = null,
  relatedModelFile = null,
  index = null,
  getOptionValue = (option) => option.id,
  classCol = "mt-2",
  required = false,
  onEventChange = (event) => { }
}) => {
  const fieldError = _.get(validation.errors, fieldName, null);
  const fieldValue = _.get(validation.values, fieldName, null);
  const isInvalidField =
    _.get(validation.touched, fieldName, false) &&
    _.get(validation.errors, fieldName, false);

  if (fieldType == "image") {
    return (
      <NibbleInputImage
        md={md}
        label={label}
        fieldName={fieldName}
        validation={validation}
        postFileFunction={postFileFunction}
        itemFile={itemFile}
        accept={accept}
        relatedModelFile={relatedModelFile}
        index={index}
      />
    );
  }

  if (fieldType === "radio") {
    return (
      <Col className={classCol} md={md}>
        {label && (
          <>
            <Label className="form-label">{label}</Label> <br />
          </>
        )}
        {selectItems.map((e, idx) => (
          <div key={idx} className="d-inline-block me-3 ">
            <Input
              type="radio"
              id={fieldName + idx}
              name={fieldName}
              maxLength={255}
              onChange={validation.handleChange}
              onBlur={validation.handleBlur}
              value={selectOptionValue(e)}
              invalid={
                validation.touched[fieldName] && validation.errors[fieldName]
              }
              checked={
                String(selectOptionValue(e)) ==
                String(validation.values[fieldName])
              }
            />{" "}
            <Label for={fieldName + idx} className="form-label fw-normal">
              {selectOptionLabel(e)}
            </Label>
          </div>
        ))}
        <FormFeedback type="invalid">
          {validation.errors[fieldName]}
        </FormFeedback>
      </Col>
    );
  }

  if (fieldType === "checkbox-single") {
    return (
      <Col className={classCol} md={md}>
        <div className="d-block me-3 ">
          <Input
            type="checkbox"
            id={fieldName}
            name={fieldName}
            onClick={(e) => {
              console.log(fieldName, e.target.checked);
              validation.setFieldValue(fieldName, e.target.checked, true);
            }}
            onBlur={validation.handleBlur}
            value={validation.values[fieldName]}
            invalid={
              validation.touched[fieldName] && validation.errors[fieldName]
            }
            checked={validation.values[fieldName]}
          />{" "}
          <Label for={fieldName} className="form-label fw-normal">
            {label}
          </Label>
        </div>

        <div
          className={classNames({
            "is-invalid": !!(
              validation.touched[fieldName] && validation.errors[fieldName]
            ),
          })}
        ></div>
        <FormFeedback type="invalid">
          {validation.errors[fieldName]}
        </FormFeedback>
      </Col>
    );
  }

  if (fieldType === "checkbox") {
    return (
      <Col className={classCol} md={md}>
        {label && (
          <>
            <Label className="form-label">{label}</Label> <br />
          </>
        )}
        {selectItems.map((e, idx) => (
          <div key={idx} className="d-block me-3 ">
            <Input
              type="checkbox"
              id={selectOptionValue(e)}
              name={fieldName}
              onClick={(e) => {
                console.log(e.target.checked);
                const newValue = [...validation.values[fieldName]];
                if (!e.target.checked) {
                  newValue.push(e.target.value);
                } else {
                  const index = validation.values[fieldName].indexOf(
                    e.target.value
                  );
                  newValue.splice(index, 1);
                }
                validation.setFieldValue(fieldName, newValue, true);
              }}
              onBlur={validation.handleBlur}
              value={selectOptionValue(e)}
              invalid={
                validation.touched[fieldName] && validation.errors[fieldName]
              }
              checked={(validation.values[fieldName] ?? []).includes(
                getOptionValue(e)
              )}
            />{" "}
            <Label for={selectOptionValue(e)} className="form-label fw-normal">
              {selectOptionLabel(e)}
            </Label>
          </div>
        ))}
        <div
          className={classNames({
            "is-invalid": !!(
              validation.touched[fieldName] && validation.errors[fieldName]
            ),
          })}
        ></div>
        <FormFeedback type="invalid">
          {validation.errors[fieldName]}
        </FormFeedback>
      </Col>
    );
  }

  if (fieldType === "textarea") {
    return (
      <Col className={classCol} md={md}>
        {label && (
          <>
            <Label className="form-label">{label}</Label>
          </>
        )}
        <Input
          type="textarea"
          className="form-control"
          name={fieldName}
          maxLength={255}
          onChange={validation.handleChange}
          onBlur={validation.handleBlur}
          value={validation.values[fieldName]}
          invalid={
            validation.touched[fieldName] && validation.errors[fieldName]
          }
        />
        <FormFeedback type="invalid">
          {validation.errors[fieldName]}
        </FormFeedback>
      </Col>
    );
  }

  if (fieldType === "multi-select") {
    return (
      <Col className={classCol} md={md}>
        {label && (
          <>
            <Label className="form-label">{label}</Label>
          </>
        )}
        <Select
          placeholder={placeHolder}
          className={classNames({
            "select-control": true,
            "is-invalid":
              validation.touched[fieldName] && validation.errors[fieldName],
          })}
          value={
            (validation.values[fieldName] || []).map((e) => {
              let newItem = selectItems.find((item) => selectOptionValue(e) == selectOptionValue(item))
              return newItem;
            })
          }
          stringify={selectStringify ?? selectOptionLabel}
          isClearable={selectIsClearable}
          isSearchable={selectIsSearchable}
          getOptionLabel={selectOptionLabel}
          getOptionValue={selectOptionValue}
          name={fieldName}
          isMulti={true}
          options={selectItems}
          onChange={(options, meta) => {
            console.log('selected options', options);
            validation.setFieldValue(
              fieldName,
              options,
              true
            );
          }}
        />
        <FormFeedback type="invalid">
          Inválido
        </FormFeedback>
      </Col>
    );
  }

  if (fieldType === "select") {
    return (
      <Col className={classCol} md={md}>
        {label && (
          <>
            <Label className="form-label">{label}</Label>
          </>
        )}
        <Select
          placeholder={placeHolder}
          className={classNames({
            "select-control": true,
            "is-invalid":
              validation.touched[fieldName] && validation.errors[fieldName],
          })}
          value={
            selectItems.filter((e) => {
              return selectOptionValue(e) === validation.values[fieldName];
            })[0] ?? null
          }
          stringify={selectStringify ?? selectOptionLabel}
          isClearable={selectIsClearable}
          isSearchable={selectIsSearchable}
          getOptionLabel={selectOptionLabel}
          getOptionValue={selectOptionValue}
          name={fieldName}
          options={selectItems}
          onChange={(option, meta) => {
            validation.setFieldValue(
              fieldName,
              selectOptionValue(option) ?? selectClearableValue,
              true
            );
          }}
        />
        <FormFeedback type="invalid">
          {validation.errors[fieldName]}
        </FormFeedback>
      </Col>
    );
  }

  if (fieldType === "time") {
    return (
      <Col className="mt-2 form-group" md={md}>
        {label && (
          <>
            <Label className="form-label">{label}</Label>
          </>
        )}

        <InputGroup
          className={classNames({
            "is-invalid":
              validation.touched[fieldName] && validation.errors[fieldName],
          })}
        >
          <Flatpickr
            value={validation.values[fieldName] ?? ""}
            className={classNames({
              "form-control": true,
              "d-block": true,
              "is-invalid":
                validation.touched[fieldName] && validation.errors[fieldName],
            })}
            placeholder="Seleccionar..."
            options={{
              enableTime: true,
              noCalendar: true,
              dateFormat: "H:i",
              time_24hr: true,
              locale: Spanish,
            }}
            onChange={([date]) => {
              console.log(date);
              validation.setFieldValue(
                fieldName,
                dayjs(date).format("HH:mm"),
                true
              );
            }}
          />
          <div className="input-group-append">
            <span className="input-group-text">
              <i className="mdi mdi-clock-outline" />
            </span>
          </div>
        </InputGroup>
        <FormFeedback type="invalid">
          {validation.errors[fieldName]}
        </FormFeedback>
      </Col>
    );
  }

  if (fieldType === "date") {
    return (
      <Col className={classCol} md={md}>
        {label && (
          <>
            <Label className="form-label">{label}</Label> <br />
          </>
        )}
        <Flatpickr
          wrapperClassName={classNames({
            "is-invalid":
              validation.touched[fieldName] && validation.errors[fieldName],
          })}
          className={classNames({
            "form-control": true,
            "is-invalid":
              validation.touched[fieldName] && validation.errors[fieldName],
          })}
          options={{
            dateFormat: "d/m/Y",
            locale: Spanish,
          }}
          name={fieldName}
          value={validation.values[fieldName] ?? null}
          onChange={(e) => validation.setFieldValue(fieldName, e[0], true)}
          invalid={
            validation.touched[fieldName] && validation.errors[fieldName]
          }
        />
        <FormFeedback type="invalid">
          {validation.errors[fieldName]}
        </FormFeedback>
      </Col>
    );
  }

  if (fieldType === "datetime") {
    return (
      <Col className={classCol} md={md}>
        {label && (
          <>
            <Label className="form-label">{label}</Label> <br />
          </>
        )}
        <Flatpickr
          wrapperClassName={classNames({
            "is-invalid":
              validation.touched[fieldName] && validation.errors[fieldName],
          })}
          className={classNames({
            "form-control": true,
            "is-invalid":
              validation.touched[fieldName] && validation.errors[fieldName],
          })}
          options={{
            enableTime: true,
            dateFormat: "d/m/Y H:i",
            time_24hr: true,
            locale: Spanish,
          }}
          name={fieldName}
          value={
            validation.values[fieldName]
              ? dayjs(validation.values[fieldName]).format("DD/MM/YYYY HH:mm")
              : null
          }
          onChange={(e) => validation.setFieldValue(fieldName, e[0], true)}
          invalid={
            validation.touched[fieldName] && validation.errors[fieldName]
          }
        />
        <FormFeedback type="invalid">
          {validation.errors[fieldName]}
        </FormFeedback>
      </Col>
    );
  }

  if (fieldType === "boolean") {
    return (
      <Col className={classCol} md={md}>
        {label && (
          <>
            <Label className="form-label">{label}</Label>{" "}
          </>
        )}
        <Input
          name={fieldName}
          type="checkbox"
          onClick={(evt) => {
            validation.setFieldValue(fieldName, !evt.target.checked, true);
          }}
          checked={validation.values[fieldName]}
        />
        <FormFeedback type="invalid">
          {validation.errors[fieldName]}
        </FormFeedback>
      </Col>
    );
  }

  if (fieldType === "search") {
    const [data, setData] = useState("");
    return (
      <Col className={classCol} md={md}>
        <div className="search-box">
          <Input
            className="form-control search"
            placeholder={placeHolder}
            name={fieldName}
            type={"text"}
            onChange={(e) => {
              setData(e.target.value);
            }}
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                validation.setFieldValue(fieldName, data, true);
              }
            }}
            onBlur={validation.handleBlur}
            value={data ?? ""}
            invalid={
              validation.touched[fieldName] && validation.errors[fieldName]
            }
            maxLength={maxLength}
            readOnly={readOnly}
          />
          <i className="ri-search-line search-icon"></i>
        </div>

        <FormFeedback type="invalid">
          {validation.errors[fieldName]}
        </FormFeedback>
      </Col>
    );
  }

  if (fieldType == "file")
    return (
      <Col className={classCol} md={md}>
        <Label className="form-label">{label}</Label>
        <Input
          className="form-control"
          placeholder={placeHolder}
          name={fieldName}
          type={fieldType}
          onChange={(event) => {
            if (event.currentTarget.files) {
              validation.setFieldValue(fieldName, event.currentTarget.files[0]);
            }
          }}
          onBlur={validation.handleBlur}
          invalid={
            validation.touched[fieldName] && validation.errors[fieldName]
          }
          maxLength={maxLength}
          readOnly={readOnly}
          disabled={disabled}
          format={format}
          accept={fieldType == "file" ? accept ?? "*/*" : null}
        />
        <FormFeedback type="invalid">
          {validation.errors[fieldName]}
        </FormFeedback>
      </Col>
    );

  if (fieldType === "number") {
    return <Col className={classCol} md={md}>
      {label && (
        <>
          <Label className="form-label">{label}</Label>
        </>
      )}
      <Input
        className="form-control"
        placeholder={placeHolder}
        name={fieldName}
        type={fieldType}
        onChange={(event) => {
          validation.handleChange(event);
          onEventChange(event);
        }}
        onBlur={validation.handleBlur}
        onWheel={(e) => e.target.blur()}
        value={fieldValue ?? ""}
        invalid={isInvalidField}
        maxLength={maxLength}
        readOnly={readOnly}
        disabled={disabled}
        required={required}
      />
      <FormFeedback type="invalid">{fieldError}</FormFeedback>
    </Col>
  }

  return (
    <Col className={classCol} md={md}>
      {label && (
        <>
          <Label className="form-label">{label}</Label>
        </>
      )}
      <Input
        className="form-control"
        placeholder={placeHolder}
        name={fieldName}
        type={fieldType}
        onChange={(event) => {
          validation.handleChange(event);
          onEventChange(event);
        }}
        onBlur={validation.handleBlur}
        value={fieldValue ?? ""}
        invalid={isInvalidField}
        maxLength={maxLength}
        readOnly={readOnly}
        disabled={disabled}
      />
      <FormFeedback type="invalid">{fieldError}</FormFeedback>
    </Col>
  );
};

NibbleBaseInput.propTypes = {
  md: PropTypes.number,
  label: PropTypes.string,
  fieldName: PropTypes.string,
  validation: PropTypes.object,
  fieldType: PropTypes.string,
  selectItems: PropTypes.array,
  selectIsClearable: PropTypes.bool,
  selectOptionValue: PropTypes.func,
  selectOptionLabel: PropTypes.func,
  selectIsSearchable: PropTypes.bool,
  selectStringify: PropTypes.func,
  postFileFunction: PropTypes.func,
  itemFile: PropTypes.any,
  maxLength: PropTypes.number,
  readOnly: PropTypes.bool,
  getOptionValue: PropTypes.func,
  placeHolder: PropTypes.string,
  selectClearableValue: PropTypes.any,
  disabled: PropTypes.bool,
  format: PropTypes.string,
  accept: PropTypes.string,
  relatedModelFile: PropTypes.string,
  index: PropTypes.number,
  classCol: PropTypes.string,
  onEventChange: PropTypes.func,
  required: PropTypes.bool,
};

export default NibbleBaseInput;
